<template>
    <div>
        <div class="card" v-if="dados">
            <div class="card-header d-flex justify-content-between">
                <template v-if="marcacao.paciente">
                    <div>
                        <span>{{ marcacao.paciente.st_nome }}</span>
                        <small class="text-muted ml-3" v-if="marcacao.paciente.cadastro && marcacao.paciente.cadastro.st_email">
                            {{ marcacao.paciente.cadastro.st_email }}
                        </small>
                    </div>
                    <div>
                        <i class="fa fa-check text-success" aria-hidden="true"></i>
                    </div>
                </template>
                <template v-else-if="marcacao.cadastro_temporario">
                    <a class="card-link" data-toggle="collapse" href="#collapseCadastro" role="button">
                        <span>{{ marcacao.cadastro_temporario.st_nome }}</span>   
                    </a>
                    <div class="text-right" v-if="marcacao.cadastro_temporario.st_cpf">
                        <i class="fa fa-check text-success" aria-hidden="true"></i>
                    </div>
                    <div class="text-right" v-else>Primeira Vez</div>
                </template>
            </div>
            <div class="collapse" :class="abrir_cadastro ? 'show' : ''" id="collapseCadastro" v-if="!marcacao.paciente">
                <div class="card-body">
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input
                                label="Nome"
                                :edicao="false"
                                required
                                :validate="validate"
                                v-model="dados.cadastro_temporario.st_nome" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="Nome Social"
                                placeholder="Opcional..."
                                :validate="validate"
                                v-model="dados.cadastro_temporario.st_nome_social" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="Nome da Mãe"
                                :validate="validate"
                                v-model="dados.cadastro_temporario.st_nome_mae" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input
                                label="e-mail"
                                type="email"
                                :validate="validate"
                                required
                                :edicao="!is_chapp"
                                v-model="dados.cadastro_temporario.st_email" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="Telefone"
                                type="fone"
                                :validate="validate"
                                :required="!!marcacao.cadastro_temporario.st_telefone"
                                v-model="dados.cadastro_temporario.st_telefone" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="Celular"
                                type="fone"
                                :validate="validate"
                                :required="!!marcacao.cadastro_temporario.st_celular"
                                v-model="dados.cadastro_temporario.st_celular" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="Sexo"
                                type="sexo"
                                required
                                :validate="validate"
                                :edicao="!is_chapp"
                                v-model="dados.cadastro_temporario.ch_sexo" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="Data de Nascimento"
                                type="date"
                                required
                                :validate="validate"
                                :rules="['nasc']"
                                :edicao="!is_chapp"
                                v-if="1 == 1"
                                v-model="dados.cadastro_temporario.dt_nascimento" />

                            <template v-else>
                                <small class="text-muted">Data de Nascimento {{ dados.cadastro_temporario.dt_nasc_mobile }}</small>
                                <date-picker
                                    type="date"
                                    value-type="format"
                                    lang="pt-BR"
                                    class="mb-3 w-100"
                                    format="DD/MM/YYYY"
                                    :input-attr="{ required: true }">
                                </date-picker>
                            </template>
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="CPF"
                                type="cpf"
                                required
                                :validate="validate"
                                :edicao="!is_chapp"
                                v-model="dados.cadastro_temporario.st_cpf" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                label="RG"
                                maxlength="10"
                                :validate="validate"
                                v-model="dados.cadastro_temporario.st_rg" />
                        </div>
                    </div>

                    <template v-if="dados.plano.id_operadora != 1">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    :label="is_chapp ? 'Atendiento' : 'Plano de Saúde'"
                                    :edicao="false"
                                    :placeholder="dados.plano.operadora ? dados.plano.operadora.search : dados.plano.search" />
                            </div>
                            <template v-if="!is_chapp">
                                <div class="col col-12 col-md-3">
                                    <div class="form-group">
                                        <az-input
                                            label="No. da Carteira do Plano"
                                            required
                                            :validate="validate"
                                            v-model="dados.cadastro_temporario.st_numero_carteira" />
                                    </div>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <div class="form-group">
                                        <az-input
                                            label="Validade da Carteira"
                                            type="date"
                                            required
                                            :validate="validate"
                                            v-model="dados.cadastro_temporario.dt_validade_carteira" />
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>

                    <cadastro-endereco 
                        :portal="true" :simples="true" 
                        :marcacao="marcacao" :dominio="domain" :token="token"
                        v-model="dados.cadastro_temporario.endereco" />

                </div>
                <div class="card-footer">
                    <az-submit @click="atualizar()">Atualizar</az-submit>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';
import CadastroEndereco from '../../components/shared/CadastroEndereco.vue';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';

export default {
    data() { 
        return { 
            dados: null, 
            finalizado: false, 
            validate: false, 
            abrir_cadastro: false, 
        }
    },

    props: ['marcacao', 'domain', 'token', 'action'],

    components: { 
        AzInput,
        AzSubmit, 
        CadastroEndereco, 
        DatePicker
    },

    computed: { 
        is_chapp: function () { 
            return ( this.marcacao && this.marcacao.plano && this.marcacao.plano.search 
                && this.marcacao.plano.search.substr(0,5).toUpperCase() == 'CHAPP' );
        }
    },
    
    methods: { 

        atualizar() { 
            $('[data-toggle="tooltip"]').tooltip("dispose");

            this.validate = true;

            this.$nextTick(() => {

                let invalids = $( '#collapseCadastro .invalid');

                if (invalids.length && $(".invalid").is(":visible")) {

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                    return;

                }

                this.$store.commit('loading', true);

                //const url = this.axios.defaults.baseURL.slice(0,-4) + 'portal/pre/store';

                this.axios.post('portal/pre/store', { 
                        cadastro_temporario: this.dados.cadastro_temporario,
                        domain: this.domain,
                        id_marcacao: this.marcacao.id_marcacao,
                        token: this.token,
                    })
                    .then(res => { 

                        if ( res.response && res.response.status >= 400 ) { 

                            // 

                        } else { 

                            if ( process.env.VUE_APP_GTAG ) { 

                                let action = 'portal-pre-cadastro-atualizado';
                                let label = this.marcacao.id_marcacao;

                                this.$gtag.event(action, {
                                    'event_category': this.domain,
                                    'event_label': label,
                                    'value': 1
                                });

                            }

                            this.$toast.add({
                                severity: "success",
                                summary: "Atenção",
                                detail: "Atualização realizada com sucesso.",
                                life: 3000
                            });

                            $('#collapseCadastro').collapse('hide');

                            this.$emit('refresh');

                        }

                    })
                    .finally(() => { 
                        this.$store.commit('loading', false);
                    });
            
            });
        }

    },

    mounted() { 
        if ( this.$route.query.c ) { 
            this.abrir_cadastro = true; 
        }

        if ( !this.paciente && this.marcacao.cadastro_temporario ) { 

            this.marcacao.cadastro_temporario.dt_nascimento = this.marcacao.cadastro_temporario.dt_nascimento.substr(0,10);
            this.marcacao.cadastro_temporario.dt_nasc_mobile = '21/02/1978';
            
            /*new Date(this.marcacao.cadastro_temporario.dt_nascimento)
                .toISOString()
                .split("T")[0];*/

            //console.log(this.marcacao.cadastro_temporario.dt_nasc_mobile);

            if ( !this.marcacao.cadastro_temporario.endereco ) { 
                this.marcacao.cadastro_temporario.endereco = { 
                    cidade: {}
                };
            }

            if ( !this.marcacao.cadastro_temporario.st_cpf ) { 
                this.$nextTick(() => { 
                    if ( ( !this.action || this.action == 'cn' ) && ( !this.is_chapp ) ) { 
                        $('#collapseCadastro').collapse('show');
                    }
                });
            }

        }

        this.dados = this.marcacao;
    }
}
</script>